import { Button } from '@cian/ui-kit';
import { IconActionList16 } from '@cian/ui-kit-design-tokens/icons';

import { clsx } from 'clsx';
import { type FC } from 'react';

import { NarrowListToggleButton } from './components/NarrowListToggleButton';
import { Switcher } from './components/Switcher';

import styles from './ViewModeSwitchers.css';

interface IViewModeSwitchersProps {
  onNarrowListToggle: VoidFunction;
  onListModeSwitch: VoidFunction;
  viewMode: 'map' | 'hybrid';
  topOffset: number;
}

export const ViewModeSwitchers: FC<IViewModeSwitchersProps> = ({
  onNarrowListToggle,
  onListModeSwitch,
  viewMode,
  topOffset,
}) => {
  return (
    <div
      className={clsx(styles['switchers'], {
        [styles['switchers--collapsed']]: viewMode === 'map',
      })}
      style={{ top: topOffset }}
    >
      <NarrowListToggleButton viewMode={viewMode} onToggle={onNarrowListToggle} />

      <Switcher>
        <Button
          beforeIcon={<IconActionList16 color="icon-main-default" />}
          data-testid="view-mode-controls.list-mode-switcher"
          size="M"
          theme="fill_white_primary"
          onClick={onListModeSwitch}
        >
          Список
        </Button>
      </Switcher>
    </div>
  );
};
